
    <fieldmagic-icon
      [icon]="icon"
    >
      <span *ngIf="label | filled; else content">{{ label | translate }}</span>
      <ng-template #content><ng-content></ng-content></ng-template>
    </fieldmagic-icon>
  